/**
 * Validator in order to validate some data.
 */
export class Validator {
  /**
   * The firstName regex.
   *
   * @type {number}
   */
  static firstNameRegex = "^([\u00C0-\u00FFa-zA-Z-'()&][\u00C0-\u00FFa-zA-Z-'()&\\s]{0,48})?[\u00C0-\u00FFa-zA-Z()&]$";

  /**
   * The firstName regex.
   *
   * @type {number}
   */
  static lastNameRegex = "^([\u00C0-\u00FFa-zA-Z-'()&][\u00C0-\u00FFa-zA-Z-'()&\\s]{0,48})?[\u00C0-\u00FFa-zA-Z()&]$";

  /**
   * The civility value for Male. Value by default Monsieur if the dom is not set.
   *
   * @type {number}
   */
  static civilityMaleValue = 'Monsieur';

  /**
   * The civility value for Miss. Value by default Madame if the dom is not set.
   *
   * @type {number}
   */
  static civilityFemaleValue = 'Madame';

  /**
   * The email min length.
   *
   * @type {number}
   */
  static emailMinLength = 6;

  /**
   * The email max length.
   *
   * @type {number}
   */
  static emailMaxLength = 165;

  /**
   * The email regex.
   *
   * @type {number}
   */
  static emailRegex = `^(?=.{${Validator.emailMinLength},${Validator.emailMaxLength}}$)(?!.+(?:\\.{2,}|\\+).+)([a-zA-Z0-9][\\w.+-]{0,62}[a-zA-Z0-9]|[a-zA-Z0-9])@[\\w-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z]{2,4}$`;

  /**
   * The phone number regex.
   *
   * @type {number}
   */
  static phoneNumberRegex = '^[ .-]*(?:0[ .-]*0|\\+)?[ .-]*(?:3[ .-]*3|5[ .-]*9[ .-]*0|5[ .-]*9[ .-]*4|5[ .-]*9[ .-]*6|2[ .-]*6[ .-]*2|0)[ .-]*(?:6|7)[ .-]*(\\d[ .-]*){8}[ .-]*$';

  /**
   * Set the firstName max length and regex.
   *
   * @param {string} regex -     - Regex.
   */
  static setFirstNameValidator(regex) {
    if (regex) {
      Validator.firstNameRegex = regex;
    }
  }

  /**
   * Set the lastName regex.
   *
   * @param {string} regex -     - Regex.
   */
  static setLastNameValidator(regex) {
    if (regex) {
      Validator.lastNameRegex = regex;
    }
  }

  /**
   * Set the email regex.
   *
   * @param {string} regex -     - Regex.
   */
  static setEmailValidator(regex) {
    if (regex) {
      Validator.emailRegex = regex;
    }
  }

  /**
   * Set the phone number regex.
   *
   * @param {string} regex -Regex.
   */
  static setPhoneNumberValidator(regex) {
    if (regex) {
      Validator.phoneNumberRegex = regex;
    }
  }

  /**
   * Validator FirstName.
   *
   * @param   {string}  value - Value of the firstName.
   * @returns {boolean} If the firstname input text is valid.
   */
  static isFirstNameValid(value) {
    const regex = new RegExp(Validator.firstNameRegex);
    const results = regex.exec(value);

    return results !== null;
  }

  /**
   * Validator phoneNumber.
   *
   * @param {string} value - Value of the phoneNumber.
   * @returns {boolean} If the phoneNumber input text is valid.
   */
  static isPhoneNumberValid(value) {
    if (!value) {
      return true;
    }
    const regex = new RegExp(Validator.phoneNumberRegex);
    return regex.exec(value) !== null;
  }

  /**
   * Validator LastName.
   *
   * @param   {string}  value - Value of the lastName.
   * @returns {boolean} If the lastName input text is valid.
   */
  static isLastNameValid(value) {
    const regex = new RegExp(Validator.lastNameRegex);
    const results = regex.exec(value);

    return results !== null;
  }

  /**
   * Validator Civility.
   *
   * @param   {string}  value - Value of the radio button.
   * @returns {boolean} If the Civility radio is valid.
   */
  static isCivilityValid(value) {
    return value === Validator.civilityMaleValue || value === Validator.civilityFemaleValue;
  }

  /**
   * Validator email.
   *
   * @param {string} value - Value of the email.
   * @returns {boolean} If the email is valid.
   */
  static isEmailValid(value) {
    const regex = new RegExp(Validator.emailRegex);
    const results = regex.exec(value);

    return results !== null && value.length >= Validator.emailMinLength && value.length <= Validator.emailMaxLength;
  }
}
